import { FaMugHot, FaCrown } from 'react-icons/fa6';
import { FaCoffee } from 'react-icons/fa';

import { images } from '../constants';


const pricing = [
    {
        id: 1,
        image: images.plan1,
        icon: <FaMugHot />, // Basic Package Icon
        title: 'Basic Package',
        price: 15.00,
        features: [
            '1 Coffee Per Day',
            'Standard Brew',
            'Free Refills for Dine-In',
            'Access to Seasonal Flavors',
            'Exclusive Discounts',
        ],
    },
    {  
        id: 2, 
        image: images.plan2,
        icon: <FaCoffee />, // Standard Package Icon
        title: 'Standard Package',
        price: 30.00,
        features: [
            '2 Coffees Per Day',
            'Choice of Brew',
            'Free Refills for Dine-In',
            'Limited-Edition Brews',
            '10% Discount on All Pastries',
        ],
    },
    {  
        id: 3,
        image: images.plan3,
        icon: <FaCrown />, // Premium Package Icon
        title: 'Premium Package',
        price: 50.00,
        features: [
            'Unlimited Coffees',
            'Choice of Brew',
            'Priority Service',
            'Free Access to All Coffee',
            '15% Discount on All Food',
        ],
    },
];

export default pricing;